import { render, staticRenderFns } from "./RestoreArchive.vue?vue&type=template&id=5638ae59&"
import script from "./RestoreArchive.vue?vue&type=script&lang=js&"
export * from "./RestoreArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports